import React from 'react';

import useAlert, { AlertProps } from 'hooks/useAlert';

import alertList from './alertList';

export interface AlertRootProps extends AlertProps {
  handleClose: () => void;
}

export type AlertKey = keyof typeof alertList;

const AlertRoot: React.FC = () => {
  const { alerts, closeAlert } = useAlert();

  return (
    <>
      {alerts.map(({ key, props }) => {
        const Component = alertList[key] as React.ComponentType<AlertRootProps>;
        const componentProps: AlertRootProps = {
          type: 'info',
          ...props,
          handleClose: () => closeAlert(key),
        };

        if (!Component) return null;

        return <Component key={key} {...componentProps} />;
      })}
    </>
  );
};

export default AlertRoot;
